import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { KeyboardKeys } from '../keyboard/keyboard-keys.enum';
import { PErrorDialogComponent } from './p-error-dialog.component';
import { PInfoDialogComponent } from './p-info-dialog/p-info-dialog.component';
import { POkCancelDialogComponent } from './p-ok-cancel-dialog.component';

@Injectable({ providedIn: 'root' })
export class PDialogService {
    openDialogRef: MatDialogRef<any> | undefined;

    constructor(private dialog: MatDialog) {}

    open<ComponentType, ConfigType = any, ResultType = any>(dialogComponent: any, config: any) {
        let panelClass = ['p-dialog'];
        if (config.panelClass != null) {
            if (Array.isArray(config.panelClass)) {
                panelClass = panelClass.concat(config.panelClass);
            } else {
                panelClass.push(config.panelClass);
            }
        }
        const dialogConfig = {
            position: {
                top: '4rem'
            },
            ...config,
            panelClass,
            hasBackdrop: true,
            backdropClass: 'p-dialog-backdrop'
        };

        const dialogRef = this.dialog.open<ComponentType, ConfigType, ResultType>(dialogComponent, dialogConfig);
        this.notifyOldUiToggleMenu(true);
        // escape not close Mat-Dialog (which need to happen by default).
        // the root-cause to this defect (d-20026) is not found, this is a work-around solution, till the root-cause will be found.
        dialogRef.keydownEvents().subscribe((event) => {
            if (event.key === KeyboardKeys.ESC.key) {
                dialogRef.close();
            }
        });
        dialogRef.afterClosed().subscribe(() => this.notifyOldUiToggleMenu(false));
        this.openDialogRef = dialogRef;

        return dialogRef;
    }

    notifyOldUiToggleMenu(toggleMenu: any) {
        window.top?.postMessage({ pyNgMigration: true, eventType: 'toggleFreezeMenu', freezeMenu: toggleMenu }, '*');
    }

    closeAll() {
        return this.dialog.closeAll();
    }

    hasOpenDialog(): boolean {
        return this.dialog.openDialogs?.length > 0;
    }

    openInfoDialog(headerText: string, bodyText: string, isHtmlContent = false, isHeaderSentenceCase = true) {
        this.open(PInfoDialogComponent, {
            panelClass: ['p-dialog', 'p-dialog-small'],
            data: {
                headerText,
                bodyText,
                isHtmlContent,
                isHeaderSentenceCase
            }
        });
    }

    public openErrorDialog(headerText: string, bodyText: string): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'p-dialog-small';
        dialogConfig.data = {
            headerText,
            bodyText
        };
        dialogConfig.autoFocus = true;
        dialogConfig.disableClose = true;

        this.open(PErrorDialogComponent, dialogConfig);
    }

    openOkCancelDialog = (
        headerText: string,
        bodyText: string,
        hideCancelButton: boolean,
        okText?: string,
        cancelText?: string
    ): MatDialogRef<any> => {
        return this.open(POkCancelDialogComponent, {
            panelClass: 'p-dialog-small',
            data: {
                headerText,
                bodyText,
                hideCancelButton,
                okText,
                cancelText
            }
        });
    };
}
